import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  name: IconName;
  size?: number;
  withDot?: boolean;
};

/**
 * The square iconbtn that pairs with the MAFA topbar / drawer headers.
 * Used for "close" / "notifications" / "more" — anything that's a single
 * action collapsed into an icon.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { name, size, withDot, className, ...rest },
  ref,
) {
  const classes = ['iconbtn'];
  if (className) classes.push(className);
  return (
    <button ref={ref} className={classes.join(' ')} {...rest}>
      <Icon name={name} size={size} />
      {withDot && <span className="dot" />}
    </button>
  );
});
